import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import CheckCircle from "@mui/icons-material/CheckCircle";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorageIcon from "@mui/icons-material/Storage";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import SecurityIcon from "@mui/icons-material/Security";
import HelpIcon from "@mui/icons-material/Help";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions() {
  const [panel1, setpanel1] = React.useState(true);
  const [panel2, setpanel2] = React.useState(true);
  const [panel3, setpanel3] = React.useState(true);
  const [panel4, setpanel4] = React.useState(true);
  const [panel5, setpanel5] = React.useState(true);
  const [panel6, setpanel6] = React.useState(true);
  const [panel7, setpanel7] = React.useState(true);
  const [panel8, setpanel8] = React.useState(true);
  const [panel9, setpanel9] = React.useState(true);

  return (
    <>
      <div style={{ paddingTop: "30px" }} className="cloud-comp">
        {/* comp table for USA started from line no 147 */}
        {/* comp table for India started from line no 1094 */}
        {/* comp table for Singapore started from line no 2043 */}

        <div
          className="row tabingcustome"
          id="pricing"
          style={{ position: "absolute", zIndex: "9999" }}
        >
          {/* button start  */}
          <div
            className="col-12 comp-but"
            style={{ position: "relative", top: "50px", left: "350px" }}
          >
            <ul
              className="nav nav-pills  justify-content-center"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active first-button"
                  id="pills-inr-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-usa-comp"
                  type="button"
                  role="tab"
                  aria-controls="pills-usa-comp"
                  aria-selected="true"
                >
                  <img src="./assets/img/usa.jpg" alt="" className="usa-logo" />
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link middle-button"
                  id="pills-usd-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-india-comp "
                  type="button"
                  role="tab"
                  aria-controls="pills-india-comp"
                  aria-selected="false"
                >
                  <img
                    src="./assets/img/india.jpg"
                    alt=""
                    className="india-logo"
                  />
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link last-button"
                  id="pills-usd-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-singapore-comp"
                  type="button"
                  role="tab"
                  aria-controls="pills-singapore-comp"
                  aria-selected="false"
                >
                  <img
                    src="./assets/img/singapore.png"
                    alt=""
                    className="singapore-logo"
                  />
                </button>
              </li>
            </ul>
          </div>
          {/* button end  */}
        </div>
        {/* usa comp  */}
        {/* usa comp  */}
        <div className="tab-content" id="pills-tabContent">
          <div
            className=" camparision tab-pane fade show active"
            role="tabpanel"
            aria-labelledby="pills-inr-tab"
            id="pills-usa-comp"
          >
            <td className="hide" style={{ color: "#e1fffe" }}>
              <img src="/Images/support_background.svg" alt="" />
            </td>
            <div className="d-flex comparision-head">
              <td>
                <span>USA PREMIUM#1</span>
                <div>₹ 179/mo</div>
                <a
                  class="btn btn-primary ctabtn "
                  href="http://my.clubhosty.com/cart.php?a=add&pid=99&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>USA PREMIUM#2</span>
                <div>₹ 229/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=100&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>USA PREMIUM#3</span>
                <div>₹ 359/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=101&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
            </div>
            <Accordion
              expanded={panel1}
              onChange={() => {
                setpanel1(!panel1);
              }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>
                  <OpenWithIcon className="comp-title-icon" />
                  Web Hosting Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Disk Space</td>
                        {/* <td>
										<CheckCircle color="success" />
									</td> */}
                        <td>40 GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                      </tr>
                      <tr>
                        <td>File (Inode) Limit</td>
                        {/* <td>
										<Cancel color="error" />
									</td> */}
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Bandwidth</td>
                        <td>400GB</td>
                        <td>Unmetered</td>
                        <td>Unmetered</td>
                      </tr>
                      <tr>
                        <td>Uptime</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                      </tr>
                      <tr>
                        <td>Hosted Domains</td>
                        <td>3</td>
                        <td>5</td>
                        <td>7</td>
                      </tr>
                      <tr>
                        <td>Parked Domains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Subdomains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Offsite Backups</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                      </tr>
                      <tr>
                        <td>cPanel (Control Panel)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>cPanel 2FA</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Free Apps</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                      </tr>
                      <tr>
                        <td>FTP Users</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Money-Back Guarantee</td>
                        <td>30 days</td>
                        <td>30 days</td>
                        <td>30 days</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel2}
              onChange={() => {
                setpanel2(!panel2);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <Inventory2Icon className="comp-title-icon" />
                  Control Panel Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Backup Manager</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                      </tr>
                      <tr>
                        <td>Virus Scanner</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                      </tr>
                      <tr>
                        <td>Hotlink Protection</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Server Status Viewer</td>
                        <td>NA</td>
                        <td>NA</td>
                        <td>NA</td>
                      </tr>
                      <tr>
                        <td>Change Language</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Web Disk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Directory Privacy</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customizable php.ini</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Cron Jobs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Simple DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Advanced DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Perl Modules</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Ruby Gems</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSL/TLS Manager</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel3}
              onChange={() => {
                setpanel3(!panel3);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <StorageIcon className="comp-title-icon" /> Server Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Webserver</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                      </tr>
                      <tr>
                        <td>PHP 5.6 - 8.2</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Node.JS 6.X - 14.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Python 2.X - 3.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Ruby 1.X - 2.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>MariaDB 10.X.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>CGI</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Perl</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Javascript</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSH Access (Jailed)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel4}
              onChange={() => {
                setpanel4(!panel4);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-database comp-title-icon"></i>Databases
                  Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>MySQL Databases</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>PHP MyAdmin</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel5}
              onChange={() => {
                setpanel5(!panel5);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <LocalPostOfficeIcon className="comp-title-icon" />
                  Email Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Email Accounts</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Forwarders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Autoresponders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>SMTP, POP3, IMAP</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td>SPF and DKIM Support</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel6}
              onChange={() => {
                setpanel6(!panel6);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <SecurityIcon className="comp-title-icon" />
                  Statistic/Web Stats
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>AWStats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Error Logs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Bandwidth Stats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Google Analytics Compatible</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel7}
              onChange={() => {
                setpanel7(!panel7);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Scripts
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Softaculous Script Installer</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Blogs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Portals/CMS</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customer Support</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Discussion Boards</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>E-Commerce</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>FAQ</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Hosting Billing</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Image Galleries</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Polls and Surveys</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Project Management</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Site Builders</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Wiki</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel8}
              onChange={() => {
                setpanel8(!panel8);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Account Resources
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>CPU Core</td>
                        <td>2</td>
                        <td>2</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>RAM</td>
                        <td>2GB</td>
                        <td>2GB</td>
                        <td>2GB</td>
                      </tr>
                      <tr>
                        <td>Concurrent connections (EP)</td>
                        <td>75</td>
                        <td>75</td>
                        <td>75</td>
                      </tr>
                      <tr>
                        <td>Number of processes (nPROC)</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>IO Limit</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel9}
              onChange={() => {
                setpanel9(!panel9);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <HelpIcon className="comp-title-icon" />
                  Support Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>24/7 Live Chat</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>24/7 Help Desk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Instant Setup</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Transfer Assistance</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          {/* india comp  */}
          <div
            className=" camparision tab-pane fade show "
            role="tabpanel"
            aria-labelledby="pills-inr-tab"
            id="pills-india-comp"
          >
            <td className="hide" style={{ color: "#e1fffe" }}>
              <img src="/Images/support_background.svg" alt="" />
            </td>
            <div className="d-flex comparision-head">
              <td>
                <span>IND PREMIUM#1</span>
                <div>₹ 179/mo</div>
                <a
                  class="btn btn-primary ctabtn "
                  href="http://my.clubhosty.com/cart.php?a=add&pid=99&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>IND PREMIUM#2</span>
                <div>₹ 229/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=100&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>IND PREMIUM#3</span>
                <div>₹ 359/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=101&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
            </div>
            <Accordion
              expanded={panel1}
              onChange={() => {
                setpanel1(!panel1);
              }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>
                  <OpenWithIcon className="comp-title-icon" />
                  Web Hosting Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Disk Space</td>
                        {/* <td>
										<CheckCircle color="success" />
									</td> */}
                        <td>40 GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                      </tr>
                      <tr>
                        <td>File (Inode) Limit</td>
                        {/* <td>
										<Cancel color="error" />
									</td> */}
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Bandwidth</td>
                        <td>400GB</td>
                        <td>Unmetered</td>
                        <td>Unmetered</td>
                      </tr>
                      <tr>
                        <td>Uptime</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                      </tr>
                      <tr>
                        <td>Hosted Domains</td>
                        <td>3</td>
                        <td>5</td>
                        <td>7</td>
                      </tr>
                      <tr>
                        <td>Parked Domains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Subdomains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Offsite Backups</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                      </tr>
                      <tr>
                        <td>cPanel (Control Panel)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>cPanel 2FA</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Free Apps</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                      </tr>
                      <tr>
                        <td>FTP Users</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Money-Back Guarantee</td>
                        <td>30 days</td>
                        <td>30 days</td>
                        <td>30 days</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel2}
              onChange={() => {
                setpanel2(!panel2);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <Inventory2Icon className="comp-title-icon" />
                  Control Panel Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Backup Manager</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                      </tr>
                      <tr>
                        <td>Virus Scanner</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                      </tr>
                      <tr>
                        <td>Hotlink Protection</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Server Status Viewer</td>
                        <td>NA</td>
                        <td>NA</td>
                        <td>NA</td>
                      </tr>
                      <tr>
                        <td>Change Language</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Web Disk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Directory Privacy</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customizable php.ini</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Cron Jobs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Simple DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Advanced DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Perl Modules</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Ruby Gems</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSL/TLS Manager</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel3}
              onChange={() => {
                setpanel3(!panel3);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <StorageIcon className="comp-title-icon" /> Server Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Webserver</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                      </tr>
                      <tr>
                        <td>PHP 5.6 - 8.2</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Node.JS 6.X - 14.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Python 2.X - 3.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Ruby 1.X - 2.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>MariaDB 10.X.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>CGI</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Perl</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Javascript</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSH Access (Jailed)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel4}
              onChange={() => {
                setpanel4(!panel4);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-database comp-title-icon"></i>Databases
                  Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>MySQL Databases</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>PHP MyAdmin</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel5}
              onChange={() => {
                setpanel5(!panel5);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <LocalPostOfficeIcon className="comp-title-icon" />
                  Email Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Email Accounts</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Forwarders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Autoresponders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>SMTP, POP3, IMAP</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td>SPF and DKIM Support</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel6}
              onChange={() => {
                setpanel6(!panel6);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <SecurityIcon className="comp-title-icon" />
                  Statistic/Web Stats
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>AWStats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Error Logs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Bandwidth Stats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Google Analytics Compatible</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel7}
              onChange={() => {
                setpanel7(!panel7);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Scripts
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Softaculous Script Installer</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Blogs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Portals/CMS</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customer Support</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Discussion Boards</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>E-Commerce</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>FAQ</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Hosting Billing</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Image Galleries</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Polls and Surveys</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Project Management</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Site Builders</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Wiki</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel8}
              onChange={() => {
                setpanel8(!panel8);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Account Resources
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>CPU Core</td>
                        <td>2</td>
                        <td>3</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>RAM</td>
                        <td>2GB</td>
                        <td>4GB</td>
                        <td>6GB</td>
                      </tr>
                      <tr>
                        <td>Concurrent connections (EP)</td>
                        <td>75</td>
                        <td>75</td>
                        <td>75</td>
                      </tr>
                      <tr>
                        <td>Number of processes (nPROC)</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>IO Limit</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel9}
              onChange={() => {
                setpanel9(!panel9);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <HelpIcon className="comp-title-icon" />
                  Support Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>24/7 Live Chat</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>24/7 Help Desk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Instant Setup</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Transfer Assistance</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          {/* singapore comp  */}
          <div
            className="camparision tab-pane fade show "
            role="tabpanel"
            aria-labelledby="pills-inr-tab"
            id="pills-singapore-comp"
          >
            <td className="hide" style={{ color: "#e1fffe" }}>
              <img src="/Images/support_background.svg" alt="" />
            </td>
            <div className="d-flex comparision-head">
              <td>
                <span>SG PREMIUM#1</span>
                <div>₹ 179/mo</div>
                <a
                  class="btn btn-primary ctabtn "
                  href="http://my.clubhosty.com/cart.php?a=add&pid=99&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>SG PREMIUM#2</span>
                <div>₹ 229/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=100&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
              <td>
                <span>SG PREMIUM#3</span>
                <div>₹ 359/mo</div>
                <a
                  class="btn btn-primary ctabtn"
                  href="http://my.clubhosty.com/cart.php?a=add&pid=101&billingcycle=monthly"
                >
                  Select Plan
                </a>
              </td>
            </div>
            <Accordion
              expanded={panel1}
              onChange={() => {
                setpanel1(!panel1);
              }}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>
                  <OpenWithIcon className="comp-title-icon" />
                  Web Hosting Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Disk Space</td>
                        {/* <td>
										<CheckCircle color="success" />
									</td> */}
                        <td>40 GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                        <td>Unmetered GB NVMe SSD</td>
                      </tr>
                      <tr>
                        <td>File (Inode) Limit</td>
                        {/* <td>
										<Cancel color="error" />
									</td> */}
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Bandwidth</td>
                        <td>400GB</td>
                        <td>Unmetered</td>
                        <td>Unmetered</td>
                      </tr>
                      <tr>
                        <td>Uptime</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                        <td>99.99%</td>
                      </tr>
                      <tr>
                        <td>Hosted Domains</td>
                        <td>3</td>
                        <td>5</td>
                        <td>7</td>
                      </tr>
                      <tr>
                        <td>Parked Domains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Subdomains</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Offsite Backups</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                        <td>Last 7 Days</td>
                      </tr>
                      <tr>
                        <td>cPanel (Control Panel)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>cPanel 2FA</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Free Apps</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                        <td>400+ apps with 1-click install</td>
                      </tr>
                      <tr>
                        <td>FTP Users</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Money-Back Guarantee</td>
                        <td>30 days</td>
                        <td>30 days</td>
                        <td>30 days</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel2}
              onChange={() => {
                setpanel2(!panel2);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <Inventory2Icon className="comp-title-icon" />
                  Control Panel Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Backup Manager</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                        <td>JetBackup</td>
                      </tr>
                      <tr>
                        <td>Virus Scanner</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                        <td>Immunify360</td>
                      </tr>
                      <tr>
                        <td>Hotlink Protection</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Server Status Viewer</td>
                        <td>NA</td>
                        <td>NA</td>
                        <td>NA</td>
                      </tr>
                      <tr>
                        <td>Change Language</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Web Disk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Directory Privacy</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customizable php.ini</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Cron Jobs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Simple DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Advanced DNS Zone Editor</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Perl Modules</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Install Ruby Gems</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSL/TLS Manager</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel3}
              onChange={() => {
                setpanel3(!panel3);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <StorageIcon className="comp-title-icon" /> Server Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Webserver</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                        <td>LiteSpeed Enterprise</td>
                      </tr>
                      <tr>
                        <td>PHP 5.6 - 8.2</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Node.JS 6.X - 14.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Python 2.X - 3.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Ruby 1.X - 2.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>MariaDB 10.X.X</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>CGI</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Perl</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Javascript</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>SSH Access (Jailed)</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel4}
              onChange={() => {
                setpanel4(!panel4);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-database comp-title-icon"></i>Databases
                  Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>MySQL Databases</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>PHP MyAdmin</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel5}
              onChange={() => {
                setpanel5(!panel5);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <LocalPostOfficeIcon className="comp-title-icon" />
                  Email Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Email Accounts</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Forwarders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>Email Autoresponders</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                        <td>Unlimited</td>
                      </tr>
                      <tr>
                        <td>SMTP, POP3, IMAP</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                      <tr>
                        <td>SPF and DKIM Support</td>
                        <td>Yes</td>
                        <td>Yes</td>
                        <td>Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel6}
              onChange={() => {
                setpanel6(!panel6);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <SecurityIcon className="comp-title-icon" />
                  Statistic/Web Stats
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>AWStats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Error Logs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Bandwidth Stats</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Google Analytics Compatible</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel7}
              onChange={() => {
                setpanel7(!panel7);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Scripts
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>Softaculous Script Installer</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Blogs</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Portals/CMS</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Customer Support</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Discussion Boards</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>E-Commerce</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>FAQ</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Hosting Billing</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Image Galleries</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Polls and Surveys</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Project Management</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Site Builders</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Wiki</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel8}
              onChange={() => {
                setpanel8(!panel8);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <i class="fa fa-code comp-title-icon"></i>Account Resources
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>CPU Core</td>
                        <td>2</td>
                        <td>2</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>RAM</td>
                        <td>2GB</td>
                        <td>2GB</td>
                        <td>2GB</td>
                      </tr>
                      <tr>
                        <td>Concurrent connections (EP)</td>
                        <td>75</td>
                        <td>75</td>
                        <td>75</td>
                      </tr>
                      <tr>
                        <td>Number of processes (nPROC)</td>
                        <td>100</td>
                        <td>100</td>
                        <td>100</td>
                      </tr>
                      <tr>
                        <td>IO Limit</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                        <td>50MBPS</td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={panel9}
              onChange={() => {
                setpanel9(!panel9);
              }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>
                  <HelpIcon className="comp-title-icon" />
                  Support Features
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <table className="camparision-table">
                    <tbody>
                      <tr>
                        <td>24/7 Live Chat</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>24/7 Help Desk</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Instant Setup</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                      <tr>
                        <td>Transfer Assistance</td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                        <td>
                          <CheckCircle color="success" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
}
